<div class="menu-container two-column settings"
  [ngClass]="{'connected' : gameManager.stateManager.wsState() == WebSocket.OPEN}">

  <div class="line hidden">
    <input [(ngModel)]="filter" type="text" [ghs-label]="'settings.filter'" [ghs-label-attribute]="'placeholder'"
      (change)="updateFilter()" (keyup)="updateFilter()">
  </div>

  <!-- GAMEPLAY -->
  <div class="line title span" ghs-setting-title-menu="gameplay" [sync]="true"></div>

  <div class="column">
    <div class="line" ghs-setting-menu="scenarioRooms"></div>
    <div class="line" ghs-setting-menu="treasures" [requires]="['scenarioRooms']"></div>
    <div class="line" ghs-setting-menu="scenarioRules"></div>
    <div class="line" ghs-setting-menu="battleGoals"></div>
    <div class="line" ghs-setting-menu="events" [requires]="['partySheet']"></div>
  </div>

  <div class="column">
    <div class="line" ghs-setting-menu="partySheet"></div>
    <div class="line" ghs-setting-menu="characterSheet"></div>
    <div class="line" ghs-setting-menu="characterAttackModifierDeck" [requires]="['characterSheet']"></div>
    <div class="line" ghs-setting-menu="characterItems"></div>
  </div>

  <!-- CHARACTER -->
  <div class="line title span" ghs-setting-title-menu="character" [sync]="true"></div>

  <div class="column">
    <div class="line" ghs-setting-menu="initiativeRequired"></div>
    <div class="line" ghs-setting-menu="hideAbsent"></div>
    <div class="line" ghs-setting-menu="treasuresLoot" [requires]="['scenarioRooms', 'treasures']"></div>
    <div class="line" ghs-setting-menu="treasuresLootItem" [requires]="['scenarioRooms', 'treasures', 'treasuresLoot']">
    </div>
    <div class="line" ghs-setting-menu="treasuresLootScenario"
      [requires]="['scenarioRooms', 'treasures', 'treasuresLoot']">
    </div>
    <div class="line" ghs-setting-menu="applyLongRest"></div>
    <div class="line" ghs-setting-menu="applyRetirement" [requires]="['characterSheet']"></div>
    <div class="line" ghs-setting-menu="characterItemsApply" [requires]="['characterItems']">
    </div>
    <div class="line" ghs-setting-menu="characterShieldRetaliate"></div>
    <div class="line" ghs-setting-menu="characterSortIndex"></div>
  </div>

  <div class="column">
    <div class="line" ghs-setting-menu="activeSummons"></div>
    <div class="line" ghs-setting-menu="characterIdentities"></div>
    <div class="line" ghs-setting-menu="characterIdentityHint" [requires]="['characterIdentities']"></div>
    <div class="line" ghs-setting-menu="scenarioRewards"></div>
    <div class="line" ghs-setting-menu="scenarioRewardsItems" [requires]="['scenarioRewards']">
    </div>
    <div class="line" ghs-setting-menu="battleGoalsReminder" [requires]="['battleGoals']"></div>
    <div class="line" ghs-setting-menu="battleGoalsCharacter" [requires]="['battleGoals']"></div>
    <div class="line" ghs-setting-menu="characterHandSize"></div>
    <div class="line" ghs-setting-menu="characterTraits"></div>
    <div class="line" ghs-setting-menu="scenarioStats"></div>
  </div>

  <!-- MONSTERS -->
  <div class="line title span" ghs-setting-title-menu="monsters" [sync]="true"></div>

  <ng-container *ngIf="settingsManager.settings.monsters">
    <div class="column">
      <div class="line" ghs-setting-menu="abilities"></div>
      <div class="line" ghs-setting-menu="calculate" [requires]="['abilities']"></div>
      <div class="line" ghs-setting-menu="calculateStats" [requires]="['abilities']"></div>
      <div class="line" ghs-setting-menu="calculateShieldStats" [requires]="['abilities', 'calculateStats']"></div>
      <div class="line" ghs-setting-menu="calculateAdvantageStats" [requires]="['abilities', 'calculateStats']"></div>
      <div class="line" ghs-setting-menu="abilityReveal" [requires]="['abilities']"></div>
      <div class="line" ghs-setting-menu="removeUnusedMonster"></div>
      <div class="line" ghs-setting-menu="addAllMonsters"></div>
    </div>

    <div class="column">
      <div class="line" ghs-setting-menu="interactiveAbilities" [requires]="['abilities']"></div>
      <div class="line" ghs-setting-menu="combineInteractiveAbilities"
        [requires]="['abilities', 'interactiveAbilities']"></div>
      <div class="line" ghs-setting-menu="abilityNumbers" [requires]="['abilities']"></div>
      <div class="line" ghs-setting-menu="showExpandedAbilityCard" [requires]="['abilities']">
      </div>
      <div class="line" ghs-setting-menu="showFullAbilityCard" [requires]="['abilities', '!showExpandedAbilityCard']"
        [checked]="settingsManager.settings.showExpandedAbilityCard"></div>
      <div class="line" ghs-setting-menu="stats"></div>
      <div class="line" ghs-setting-menu="hideStats" [requires]="['stats']"></div>
    </div>
  </ng-container>

  <!-- STANDEES -->
  <div class="line title span" ghs-setting-title-menu="standees" [sync]="true"></div>

  <div class="column">
    <ng-container *ngIf="settingsManager.settings.monsters">
      <div class="line" ghs-setting-menu="eliteFirst" [requires]="['standees']"></div>
    </ng-container>
    <div class="line" ghs-setting-menu="activeStandees" [requires]="['standees']"></div>
    <div class="line" ghs-setting-menu="automaticStandees" [requires]="['standees', 'scenarioRooms']"></div>
    <div class="line" ghs-setting-menu="standeeStats" [requires]="['standees']"></div>
  </div>

  <div class="column" *ngIf="settingsManager.settings.monsters">
    <div class="line" ghs-setting-menu="automaticStandeesDialog"
      [requires]="['standees', 'scenarioRooms', 'automaticStandees', '!randomStandees']">
    </div>
    <div class="line" ghs-setting-menu="randomStandees" [requires]="['standees']"></div>
    <div class="line" ghs-setting-menu="standees"></div>
    <div class="line" ghs-setting-menu="standeeShieldRetaliate" [requires]="['standees']"></div>
  </div>

  <!-- CONDITION/ELEMENTS -->
  <div class="line title span" ghs-setting-title-menu="conditions" [sync]="true"></div>

  <div class="column">
    <div class="line" ghs-setting-menu="expireConditions"></div>
    <div class="line" ghs-setting-menu="applyConditions"></div>

    <div class="column">
      <div class="line" [ngClass]="{'disabled' : !settingsManager.settings.applyConditions}">
        <div class="condition-list">
          <div class="hint-container" *ngFor="let condition of applyConditionsExcludes; let i = index;">
            <div tabclick class="condition"
              [ngClass]="{'immunity': settingsManager.settings.applyConditionsExcludes.indexOf(condition.name) != -1}"
              (click)="toggleApplyConditionsExclude(condition.name)">
              <img
                [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') + '/condition/' + condition.name + '.svg'" />
              <span *ngIf="condition.types.indexOf(ConditionType.value) != -1" class="value">X</span>
            </div>
            <img src="./assets/images/hint.svg" class="hint-trigger ghs-svg">
            <span class="hint" [ngClass]="{'right': i > 2}">
              <span class="text" [ghs-label]="'settings.applyConditions.hint.' + condition.name "></span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="column">
    <div class="line" ghs-setting-menu="moveElements"></div>
    <div class="line" ghs-setting-menu="activeApplyConditions" [requires]="['applyConditions']">
    </div>

    <div class="column">
      <div class="line">
        <div class="condition-list">
          <div class="hint-container" *ngFor="let condition of activeApplyConditionsExcludes; let i = index">
            <div tabclick class="condition"
              [ngClass]="{'immunity': settingsManager.settings.activeApplyConditionsExcludes.indexOf(condition.name) != -1, 'disabled' : !settingsManager.settings.applyConditions || !settingsManager.settings.activeApplyConditions}"
              (click)="toggleActiveApplyConditionsExclude(condition.name)">
              <img
                [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') + '/condition/' + condition.name + '.svg'" />
              <span *ngIf="condition.types.indexOf(ConditionType.value) != -1" class="value">X</span>
            </div>
            <img src="./assets/images/hint.svg" class="hint-trigger ghs-svg">
            <span class="hint" [ngClass]="{'right': i > 2}">
              <span class="text" [ghs-label]="'settings.activeApplyConditions.hint.' + condition.name"></span>
            </span>
          </div>
        </div>
      </div>
    </div>


    <div class="column"
      *ngIf="settingsManager.settings.applyConditions && settingsManager.settings.activeApplyConditions">
      <div class="line"
        [ngClass]="{'disabled' : !settingsManager.settings.applyConditions || !settingsManager.settings.activeApplyConditions}">
        <div class="hint-container inline">
          <label [ghs-label]="'settings.activeApplyConditions.auto'"></label>
          <img src="./assets/images/hint.svg" class="hint-trigger ghs-svg">
          <span class="hint">
            <span class="text" [ghs-label]="'settings.activeApplyConditions.auto.hint'"></span>
          </span>
        </div>
        <div class="condition-list">
          <ng-container *ngFor="let condition of activeApplyConditionsAuto; let i = index">
            <div class="hint-container"
              *ngIf="settingsManager.settings.activeApplyConditionsExcludes.indexOf(condition.name) == -1">
              <div tabclick class="condition"
                [ngClass]="{'immunity': settingsManager.settings.activeApplyConditionsAuto.indexOf(condition.name) == -1 || settingsManager.settings.activeApplyConditionsExcludes.indexOf(condition.name) != -1, 'disabled': settingsManager.settings.activeApplyConditionsExcludes.indexOf(condition.name) != -1}"
                (click)="toggleActiveApplyConditionsAuto(condition.name)">
                <img
                  [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') + '/condition/' + condition.name + '.svg'" />
                <span *ngIf="condition.types.indexOf(ConditionType.value) != -1" class="value">X</span>
              </div>
              <img src="./assets/images/hint.svg" class="hint-trigger ghs-svg">
              <span class="hint" [ngClass]="{'right': i > 2}">
                <span class="text" [ghs-label]="'settings.activeApplyConditions.auto.hint.' + condition.name"></span>
              </span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="separator"></div>

  <!-- FROSTHAVEN -->
  <div class="line title span" ghs-setting-title-menu="fhRules" [sync]="true"></div>

  <div class="column">
    <div class="line" ghs-setting-menu="applyLoot" [requires]="['lootDeck']"></div>
    <div class="line" ghs-setting-menu="applyLootRandomItem" [requires]="['lootDeck', 'applyLoot', 'characterItems']">
    </div>
    <div class="line" ghs-setting-menu="alwaysLootApplyDialog" [requires]="['lootDeck', 'applyLoot']"></div>
    <div class="line" ghs-setting-menu="automaticPassTime" [disabled]="!gameManager.fhRules()"></div>
    <div class="line" ghs-setting-menu="applyBuildingRewards" [disabled]="!gameManager.fhRules()"></div>
    <div class="line" ghs-setting-menu="unlockEnvelopeBuildings" [disabled]="!gameManager.fhRules()"></div>
    <div class="line" ghs-setting-menu="fhGhItems" [disabled]="!gameManager.fhRules()"
      [requiresOne]="['characterItems', 'characterSheet']">
    </div>
    <div *ngIf="gameManager.challengesManager.available" class="line" ghs-setting-menu="fhChallenges"
      [disabled]="!gameManager.fhRules()"></div>
    <div *ngIf="gameManager.trialsManager.available" class="line" ghs-setting-menu="fhTrials"
      [disabled]="!gameManager.fhRules()" [labelSuffix]="gameManager.trialsManager.favorsAvailable ? 'favors' : ''">
    </div>
    <div *ngIf="gameManager.buildingsManager.petsAvailable" class="line" ghs-setting-menu="fhPets"
      [disabled]="!gameManager.fhRules()"></div>
  </div>

  <div class="column">
    <div class="line" ghs-setting-menu="alwaysLootDeck" [disabled]="gameManager.fhRules()" [requires]="['lootDeck']"
      [checked]="settingsManager.settings.lootDeck && gameManager.fhRules()">
    </div>
    <div class="line" ghs-setting-menu="battleGoalsFh" [disabled]="gameManager.fhRules()" [requires]="['battleGoals']"
      [checked]="settingsManager.settings.battleGoals && gameManager.fhRules()">
    </div>
    <div class="line" ghs-setting-menu="alwaysAllyAttackModifierDeck"
      [disabled]="!settingsManager.settings.allyAttackModifierDeck"></div>
    <div class="line" ghs-setting-menu="alwaysHazardousTerrain" [disabled]="gameManager.fhRules()"
      [checked]="gameManager.fhRules()"></div>
    <div class="line" ghs-setting-menu="alwaysFhSolo" [disabled]="gameManager.fhRules()"
      [checked]="gameManager.fhRules()"></div>
    <div class="line" ghs-setting-menu="alwaysFhAdvantage" [disabled]="gameManager.fhRules()"
      [requires]="['amAdvantage']" [checked]="settingsManager.settings.amAdvantage && gameManager.fhRules()"></div>
    <div *ngIf="settingsManager.settings.amAdvantage" class="line" ghs-setting-menu="amAdvantageHouseRule"
      [requires]="['amAdvantage', 'alwaysFhAdvantage']"></div>
    <div *ngIf="gameManager.challengesManager.available" class="line" ghs-setting-menu="fhChallengesApply"
      [disabled]="!gameManager.fhRules()" [requires]="['fhChallenges']"></div>
    <div *ngIf="gameManager.trialsManager.available" class="line" ghs-setting-menu="fhTrialsApply"
      [disabled]="!gameManager.fhRules() || !gameManager.trialsManager.trialsEnabled && !gameManager.trialsManager.favorsEnabled"
      [requires]="['fhTrials']" [labelSuffix]="gameManager.trialsManager.favorsAvailable ? 'favors' : ''">
    </div>
  </div>


  <div class="separator"></div>

  <!-- BUTTON&BUGS -->
  <div class="line title span" ghs-setting-title-menu="gh2eRules" [sync]="true"></div>

  <div class="column">
    <div class="line" ghs-setting-menu="gh2eImbuement"></div>
  </div>

  <ng-container *ngIf="gameManager.bbRules()">
    <div class="separator"></div>

    <!-- BUTTON&BUGS -->
    <div class="line title span" ghs-setting-title-menu="bbRules" [sync]="true"></div>

    <div class="column">
      <div class="line" ghs-setting-menu="bbChars"></div>
      <div class="line" ghs-setting-menu="bbAm" [requires]="['monsterAttackModifierDeck']"></div>
    </div>

    <div class="column">
      <div class="line" ghs-setting-menu="bbStandeeLimit" [requires]="['standees']"></div>
    </div>
  </ng-container>

  <div class="separator"></div>

  <!-- ADDITIONAL -->
  <div class="line title span" ghs-setting-title-menu="additional" [sync]="true"></div>

  <div class="column">
    <div class="line" ghs-setting-menu="turnConfirmation" [requiresOne]="['expireConditions', 'applyConditions']"></div>
    <div *ngIf="!settingsManager.settings.initiativeRequired" class="line" ghs-setting-menu="automaticFirstFigure"
      [requires]="['!initiativeRequired']"></div>
    <div class="line" ghs-setting-menu="scenarioRulesAutoapply" [requires]="['scenarioRules']">
    </div>
    <div class="line" ghs-setting-menu="automaticUnlocking"></div>
    <div class="line" ghs-setting-menu="summons"></div>
    <div class="line" ghs-setting-menu="eventsApply" [requires]="['events','partySheet']"></div>
    <div class="line" ghs-setting-menu="eventsDraw" [requires]="['events','partySheet']"></div>
  </div>

  <div class="column">
    <div class="line" ghs-setting-menu="lootDeck"></div>
    <div class="line" ghs-setting-menu="allyAttackModifierDeck"></div>
    <div class="line" ghs-setting-menu="monsters"></div>
    <div class="line" ghs-setting-menu="monsterAttackModifierDeck"></div>
    <div class="line" ghs-setting-menu="amAdvantage"></div>
    <div class="line" ghs-setting-menu="damageHP"></div>
  </div>

  <!-- INTERFACE -->
  <div class="line title span" ghs-setting-title-menu="interface"></div>

  <div class="column">
    <div class="line" ghs-setting-menu="fhStyle"></div>
    <div class="line" ghs-setting-menu="dragValues"></div>
    <div class="line" ghs-setting-menu="pressDoubleClick"></div>
    <div class="line" ghs-setting-menu="dragFigures"></div>
    <div class="line" ghs-setting-menu="automaticAttackModifierFullscreen" [requires]="['portraitMode']"></div>
    <div class="line" ghs-setting-menu="characterSheetCompact" [requires]="['characterSheet']">
    </div>
  </div>

  <div class="column">
    <div class="line" ghs-setting-menu="characterAttackModifierAnimate"
      [requires]="['characterSheet', 'characterAttackModifierDeck']">
    </div>
    <div class="line" ghs-setting-menu="characterAttackModifierDeckPermanent"
      [requires]="['characterSheet', 'characterAttackModifierDeck']">
    </div>
    <div class="line" ghs-setting-menu="characterAttackModifierDeckPermanentActive"
      [requires]="['characterSheet', 'characterAttackModifierDeck', 'characterAttackModifierDeckPermanent']">
    </div>
    <div class="line" ghs-setting-menu="characterItemsPermanent" [requires]="['characterItems']">
    </div>
    <div class="line" ghs-setting-menu="characterItemsPermanentActive"
      [requires]="['characterItems','characterItemsPermanent']"></div>
    <div class="line" ghs-setting-menu="damageHPToggle"></div>
  </div>

  <div class="separator"></div>

  <!-- Game clock-->
  <div class="column">
    <div class="line" ghs-setting-menu="gameClock"></div>
    <div class="line" ghs-setting-menu="gameClockMerge" [requires]="['gameClock']"></div>
  </div>

  <div class="column">
    <div class="line" ghs-setting-menu="automaticGameClock" [requires]="['gameClock']"></div>
    <div class="line" ghs-setting-menu="automaticGameClockFocus" [requires]="['gameClock', 'automaticGameClock']"></div>
  </div>

  <div class="separator"></div>

  <div class="column">
    <div class="line ">
      <a ghs-pointer-input (singleClick)="zoomOut()" (doubleClick)="zoomOut(true)">
        <span [ghs-label]="'settings.zoom.out'"></span>
      </a>
    </div>

    <div class="line">
      <a ghs-pointer-input (singleClick)="zoomIn()" (doubleClick)="zoomIn(true)">
        <span [ghs-label]="'settings.zoom.in'"></span>
      </a>
    </div>

    <div class="line">
      <a (click)="resetZoom()">
        <span [ghs-label]="'settings.zoom.reset'"></span>
      </a>
    </div>

    <div class="line" ghs-setting-menu="pinchZoom"></div>
    <div class="line" ghs-setting-menu="fullscreen"></div>
    <div class="line" ghs-setting-menu="autoscroll"></div>
    <div class="line" ghs-setting-menu="portraitMode"></div>
    <div class="line" ghs-setting-menu="animations"></div>
    <div class="line" ghs-setting-menu="statAnimations"></div>
    <div class="line" ghs-setting-menu="barsize" type="range" [min]="0.1" [max]="2"></div>
    <div class="line" ghs-setting-menu="fontsize" type="range" [min]="0.1" [max]="2"></div>
  </div>

  <div class="column">
    <div class="line" ghs-setting-menu="hints"></div>
    <div class="line" ghs-setting-menu="tooltips"></div>
    <div class="line" ghs-setting-menu="backupHint"></div>
    <div class="line" ghs-setting-menu="initiativeRoundConfirm" [requires]="['initiativeRequired']"></div>
    <div class="line" ghs-setting-menu="errata"></div>
    <div class="line" ghs-setting-menu="columns"></div>
    <div class="line" ghs-setting-menu="columnsForce" [requires]="['columns']"></div>
    <div class="line" ghs-setting-menu="artwork"></div>
    <div *ngIf="wakeLock" class="line" ghs-setting-menu="wakeLock"></div>
  </div>

  <div class="separator"></div>

  <div class="line" ghs-setting-menu="maxUndo" type="number" [min]="0" [max]="storageManager.db ? '' : 50"
    [hint]="!storageManager.db" [additionalHint]="platform.FIREFOX ? 'settings.maxUndo.hint.firefox' : ''"></div>

  <div class="line" ghs-setting-menu="browserNavigation" [disabled]="true" [hint]="false"></div>

  <div class="column">
    <div class="line title" ghs-setting-title-menu="locale" [sync]="true"></div>
    <div ghs-setting-menu="locale" [values]="settingsManager.locales"></div>
    <div class="line">
      <a href="https://translate.gloomhaven-secretariat.de/" target="_blank" [ghs-tooltip]="'settings.locale.help.hint'"
        [originY]="'top'" [overlayY]="'bottom'">
        <img class="ghs-svg" src="./assets/images/hint.svg">&nbsp;
        <span [ghs-label]="'settings.locale.help'"></span>
      </a>
    </div>
  </div>

  <div class="column">
    <div class="line title" ghs-setting-title-menu="theme"></div>

    <div ghs-setting-menu="theme" [values]="['default', 'fh', 'modern', 'bb']"></div>

    <div class="separator"></div>

    <div class="line" ghs-setting-menu="automaticTheme"></div>
    <div class="line" ghs-setting-menu="characterFullView"></div>
    <div class="line" ghs-setting-menu="characterCompact" [disabled]="settingsManager.settings.theme  == 'modern'">
    </div>
    <div class="line" ghs-setting-menu="playerNumber"></div>
    <div class="line" ghs-setting-menu="hideCharacterHP"></div>
    <div class="line" ghs-setting-menu="hideCharacterLoot"></div>
    <div class="line" ghs-setting-menu="hideCharacterXP"></div>
  </div>

  <div class="separator"></div>

  <div class="line">
    <a tabclick (click)="helperDefaults()">
      <span [ghs-label]="'settings.helperDefaults'"></span>
    </a>
  </div>

  <div class="line">
    <a tabclick (click)="lurkarsDefaults()">
      <span [ghs-label]="'settings.lurkarsDefaults'"></span>
    </a>
  </div>

  <div class="line">
    <a tabclick (click)="xhaDefaults()">
      <span [ghs-label]="'settings.xhaDefaults'"></span>
    </a>
  </div>

  <div class="separator"></div>

  <div class="line">
    <a tabclick (click)="setMenu.emit(SubMenu.debug)">
      <span [ghs-label]="'settings.debug'"></span>
    </a>
  </div>
</div>